module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.certinfo.certType === 1),
      expression: "certinfo.certType === 1"
    }],
    staticClass: "astyle",
    attrs: {
      "href": _vm.ahref
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.dachuzhengshu')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftCtrl",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload')) + _vm._s(_vm.$t('lin_global.zhengshu')))]), _vm._v(" "), _c('el-row', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.createTime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.createTime) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.distributorName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateDesc) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b8a543"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safe/myCert.vue
// module id = 974
// module chunks = 0